import React from "react";

export default function Divider({marginStyle}) {
  return (
    <div className={`line mx-auto my-[55px] md:my-[4%]  w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%] ${marginStyle}`}></div>
  );
}
